import { Col, Collapse, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import TagComponent from "../../../biblio/TagComponent";
import dayjs from "dayjs";
interface CollapseProps {
  className?: string;
  collapseData: any[];
  // currentRef: any;
}
const ServicesRequestsCollapse = ({
  // currentRef,
  collapseData,
}: CollapseProps) => {
  const { t } = useTranslation();
  return (
    <div className="takaful--collapse-profile-container">
      <Collapse
        className={`takaful--collapse-beneficiary-services takaful--collapse-profile `}
        accordion
        defaultActiveKey={["0"]}
      >
        {collapseData?.map((element, index) => (
          <Collapse.Panel
            className="takaful--header-profile-Panel"
            showArrow={false}
            header={
              <div className="takaful--header-profile-container">
                <Row
                  justify={"space-between"}
                  className="takaful--content-profile-box1"
                  style={{ marginBottom: "0" }}
                >
                  <Col xxl={4} xl={4} lg={4} md={4} sm={0} xs={0}>
                    <span className="takaful--content-services-request-span">
                      {element?.name}
                    </span>
                  </Col>
                  <Col
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={4}
                    sm={0}
                    xs={0}
                    style={{ marginLeft: "-1.6rem" }}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.date
                        ? dayjs(element?.date, "YYYY-MM-DD").format(
                            "YYYY/MM/DD"
                          )
                        : ""}
                    </span>
                  </Col>
                  <Col
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={4}
                    sm={12}
                    xs={12}
                    className="takaful--col-content"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.assistance_id}
                    </span>
                  </Col>
                  <Col
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={4}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <TagComponent
                      className="takaful--tag-component"
                      width="100%"
                      state={element?.disbursement_status}
                      orangeValue="partial_disbursement"
                      greenValue="disbursed"
                      text={t(
                        `disbursement_status.${element?.disbursement_status}`
                      )}
                    />
                  </Col>
                  <Col
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={4}
                    sm={12}
                    xs={10}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <TagComponent
                      className="takaful--tag-component"
                      width="100%"
                      state={element?.state}
                      orangeValue="in_progress"
                      greenValue="done"
                      redValue="cancel"
                      text={element?.stage_id}
                    />
                  </Col>
                </Row>
              </div>
            }
            key={index}
          >
            <div style={{ padding: "0rem 1rem 0rem 1rem" }}>
              <Row
                justify={"space-between"}
                className={`takaful--content-profile-box1`}
              >
                <Col
                  xxl={5}
                  xl={5}
                  lg={5}
                  md={5}
                  sm={12}
                  xs={12}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    رقم الطلب
                  </p>
                </Col>
                <Col
                  xxl={6}
                  xl={6}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={12}
                  className="takaful--content-profile-col"
                >
                  <span className="takaful--content-services-request-span takaful--color-span">
                    {element?.name}
                  </span>
                </Col>

                <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

                <Col
                  xxl={5}
                  xl={5}
                  lg={5}
                  md={5}
                  sm={12}
                  xs={12}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    تاريخ الطلب
                  </p>
                </Col>
                <Col
                  xxl={6}
                  xl={6}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={12}
                  className="takaful--content-profile-col"
                >
                  <span className="takaful--content-services-request-span takaful--color-span">
                    {element?.date
                      ? dayjs(element?.date, "YYYY-MM-DD").format("YYYY/MM/DD")
                      : ""}
                  </span>
                </Col>
              </Row>
              {element?.amount > 0 ? (
                element?.person_id !== false ? (
                  <Row
                    justify={"space-between"}
                    className={`takaful--content-profile-box1`}
                  >
                    <Col
                      xxl={5}
                      xl={5}
                      lg={5}
                      md={5}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    >
                      <p className="takaful--content-services-request-p">
                        اسم المستفيد(ة)
                      </p>
                    </Col>
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    >
                      <span className="takaful--content-services-request-span takaful--color-span">
                        {element?.person_id}
                      </span>
                    </Col>

                    <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

                    <Col
                      xxl={5}
                      xl={5}
                      lg={5}
                      md={5}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    >
                      <p className="takaful--content-services-request-p">
                        المبلغ
                      </p>
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                      <span className="takaful--content-services-request-span takaful--color-span">
                        {element?.amount}
                      </span>
                    </Col>
                  </Row>
                ) : (
                  <Row className={`takaful--content-profile-box1`}>
                    <Col
                      xxl={5}
                      xl={5}
                      lg={5}
                      md={5}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    >
                      <p className="takaful--content-services-request-p">
                        المبلغ{" "}
                      </p>
                    </Col>
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col takaful--col--amount-not-visible "
                    >
                      <span className="takaful--content-services-request-span takaful--color-span">
                        {element?.amount}
                      </span>
                    </Col>
                  </Row>
                )
              ) : element?.person_id !== false ? (
                <Row className={`takaful--content-profile-box1`}>
                  <Col
                    xxl={5}
                    xl={5}
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      اسم المستفيد(ة)
                    </p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col takaful--col--amount-not-visible "
                  >
                    <span className="takaful--content-services-request-span takaful--color-span">
                      {element?.person_id}
                    </span>
                  </Col>
                </Row>
              ) : null}

              {element?.product_id !== false && (
                <Row
                  justify={"space-between"}
                  className="takaful--content-profile-box1"
                >
                  <Col
                    xxl={5}
                    xl={5}
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      المنتج
                    </p>
                  </Col>
                  <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <span className="takaful--content-services-request-span takaful--color-span">
                      {element?.product_id}
                    </span>
                  </Col>
                  <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

                  <Col
                    xxl={5}
                    xl={5}
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      الكمية
                    </p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span takaful--color-span">
                      {element?.quantity}
                    </span>
                  </Col>
                </Row>
              )}

              <Row
                justify={"space-between"}
                className="takaful--content-profile-box1"
              >
                <Col
                  xxl={5}
                  xl={5}
                  lg={5}
                  md={5}
                  sm={12}
                  xs={12}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    {" "}
                    نوع الخدمة
                  </p>
                </Col>
                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                  <span className="takaful--content-services-request-span takaful--color-span">
                    {" "}
                    {element?.assistance_id}
                  </span>
                </Col>
                <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

                <Col
                  xxl={5}
                  xl={5}
                  lg={5}
                  md={5}
                  sm={12}
                  xs={12}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    التفاصيل
                  </p>
                </Col>
                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                  <span className="takaful--content-services-request-span takaful--color-span">
                    {element?.details}
                  </span>
                </Col>
              </Row>
            </div>
          </Collapse.Panel>
        ))}
      </Collapse>
    </div>
  );
};

export default ServicesRequestsCollapse;
